import "markdown-it";
import { timePeriodsEqual } from "../date/timePeriodsEqual.js";
function getPreparedScheduleGroups(preparedSchedule) {
  const resolvedSchedule = [];
  let currentSchedule = null;
  for (let i = 0; i < preparedSchedule.length; i++) {
    const { day, beforeBreak, afterBreak, isOpen24hours } = preparedSchedule[i];
    if (!currentSchedule || !timePeriodsEqual(currentSchedule.beforeBreak, beforeBreak) || !timePeriodsEqual(currentSchedule.afterBreak, afterBreak)) {
      currentSchedule = {
        days: [day],
        beforeBreak,
        afterBreak,
        isOpen24hours
      };
      resolvedSchedule.push(currentSchedule);
      continue;
    }
    currentSchedule.days.push(day);
  }
  return resolvedSchedule.map(({ days, beforeBreak, afterBreak, isOpen24hours: fullDay }) => {
    const times = [beforeBreak];
    if (afterBreak) {
      times.push(afterBreak);
    }
    return { days, times, fullDay };
  });
}
export {
  getPreparedScheduleGroups
};
